import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa',
      type: 'string',
      fieldRequired: true
    },
    mask: {
      title: 'Maska numeru',
      type: 'string'
    },
    body: {
      title: 'Treść widoku',
      type: 'string',
      fieldRequired: true
    },
    headerId: { title: 'Nagłówek', type: 'number' },
    hideHeaderOnFirstPage: {
      title: 'Ukryj nagłówek na pierwszej stronie',
      type: 'boolean',
      default: false
    },
    footerId: { title: 'Stopka', type: 'number' },
    hideFooterOnFirstPage: {
      title: 'Ukryj stopkę na pierwszej stronie',
      type: 'boolean',
      default: false
    },
    schemaId: { fieldRequired: false, title: 'Schemat', type: 'number' }
  },
  allOf: [validationMessages]
};
